export const BOOKING_URL = 'https://tidycal.com/m20r9zd/productivity-blueprint-session';
export const CONTACT_EMAIL = 'contact@tm.hannakinez.com';

export const SOCIAL = {
  linkedin: 'https://www.linkedin.com/in/anna-kinez/',
  instagram: 'https://www.instagram.com/anna_kinez/',
  youtube: 'https://www.youtube.com/@somaticmovementeducation3095',
};

export interface NavChild {
  label: string;
  to?: string; // page inside this app (may include #section)
  href?: string; // separate page or external site
  external?: boolean; // opens in a new tab
}

export const NAV_ITEMS: { to: string; label: string; children?: NavChild[] }[] = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About' },
  { to: '/work-with-me', label: 'Work With Me' },
  {
    to: '/resources',
    label: 'Resources',
    children: [
      { label: 'Healing Herbs', to: '/resources#herbs' },
      { label: 'PDF Resources', to: '/resources#guides' },
      { label: 'Workshops', href: '/rechargew.html' },
      { label: 'YouTube Channel', href: SOCIAL.youtube, external: true },
      { label: 'Quick Insights on Instagram', href: SOCIAL.instagram, external: true },
    ],
  },
  { to: '/contact', label: 'Contact' },
];
